import { xBaseTheme } from "@eisinc/XDL/types";

import { screen } from "@eisinc/XDL/Helpers";
import DrawerPresentationPropsDefault from "@insite/mobius/Drawer/presentationProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

export default {
    defaultProps: {
        ...DrawerPresentationPropsDefault,
        cssOverrides: {
            drawerContainer: css`
                ${screen("gt", "md")`
                    > div > div {
                        max-width: 1440px;
                        padding-left: 10px;
                        padding-right: 10px;
                        margin: 0 auto;
                        width: 100%;
                    }

                    #drawerTitle {
                        padding-top: 20px;
                    }
                `}
                #drawerTitle {
                    > button {
                        padding: 0;
                        &:hover {
                            background: ${getColor("common.white")};
                            border-color: ${getColor("common.white")};
                        }
                    }
                }
            `,
        },
    },
} as xBaseTheme["drawer"];
